import api from "./httpClient";
import { API_PATHS } from "./apiPaths";

const unwrap = (response) => response?.data?.data ?? response?.data ?? response ?? {};

export const listEmployees = async () => {
  const data = unwrap(await api.get(API_PATHS.superAdmin.employees(), { cache: "no-store" }));
  if (Array.isArray(data)) return data;
  return data?.content || data?.employees || data?.items || [];
};

export const createEmployee = async (payload) => unwrap(await api.post(API_PATHS.superAdmin.employees(), payload));
export const updateEmployee = async (employeeId, payload) => unwrap(await api.put(API_PATHS.superAdmin.employeeById(employeeId), payload));
export const updateEmployeeStatus = async (employeeId, status) => unwrap(await api.patch(API_PATHS.superAdmin.employeeStatus(employeeId), { status }));
export const resendEmployeeInvitation = async (employeeId) => unwrap(await api.post(API_PATHS.superAdmin.resendEmployeeInvitation(employeeId)));
